var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35,
    stroke: "#FFB341",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0007 52.6654C45.2054 52.6654 52.6673 45.2034 52.6673 35.9987C52.6673 26.794 45.2054 19.332 36.0007 19.332C26.7959 19.332 19.334 26.794 19.334 35.9987C19.334 45.2034 26.7959 52.6654 36.0007 52.6654Z",
    fill: "#FFB341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 28.082C36.6904 28.082 37.25 28.6417 37.25 29.332V35.4809L41.0506 39.2815C41.5387 39.7696 41.5387 40.5611 41.0506 41.0492C40.5624 41.5374 39.7709 41.5374 39.2828 41.0492L35.1161 36.8826C34.8817 36.6482 34.75 36.3302 34.75 35.9987V29.332C34.75 28.6417 35.3096 28.082 36 28.082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentProcess);
export default __webpack_public_path__ + "static/media/payment-process.44dfcc02776707cfbaad653888e5f762.svg";
export { ForwardRef as ReactComponent };